import { render, staticRenderFns } from "./Years.vue?vue&type=template&id=032ac158&scoped=true&"
import script from "@/views/Years/Years.ts?vue&type=script&lang=ts&"
export * from "@/views/Years/Years.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Years/years.scss?vue&type=style&index=0&id=032ac158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032ac158",
  null
  
)

export default component.exports